import 'front/dy_framework/dy_lazyLoader/dy_lazyLoader_configuration.js';
import 'lazysizes/plugins/object-fit/ls.object-fit.js';

import 'lazysizes/lazysizes.js'
import 'lazysizes/plugins/parent-fit/ls.parent-fit.js'
import 'lazysizes/plugins/respimg/ls.respimg.js'
import 'lazysizes/plugins/optimumx/ls.optimumx.js'

import 'front/dy_framework/dy_lazyLoader/dy_lazyLoader_allLazyLoaded.js';

import bowser from 'bowser/bowser.js'

(function () {
  'use strict';

var dy_lazyLoader = function () {
  var self = this;

  self.init();

};

dy_lazyLoader.prototype.init = function() {
  var self = this;

  self.initLazySizes();

  self.initBadBrowser();

};

dy_lazyLoader.prototype.initLazySizes = function() {
  var self = this;

  lazySizes.init();

  // Bind turbolinks events
  document.addEventListener('turbolinks:load', function(localSelf/*, event*/) {
    localSelf.initBadBrowser();
  }.bind(null, self));
};

dy_lazyLoader.prototype.initBadBrowser = function() {
  //var self = this;
  if (bowser.safari && bowser.version < 9.1) {
    var elements = jQuery('.dy_lazyLoader');

    elements.each(function( /*index*/ ){
      var element = jQuery(this);

      var url = element.attr('data-src');
      element.attr('src', url);

    });
  }
};

/*----------------------------------------------------------------------------*/
// Component Public
/*----------------------------------------------------------------------------*/
  jQuery(function () {
    window.dy_lazyLoader = new dy_lazyLoader();
  });

  document.addEventListener('turbolinks:load', function(/*event*/) {

  });


}());
